import type { ReactNode } from 'react';

/**
 * Polite status line for a transient auth phase (session check, redirect).
 * Pure and copy-agnostic — the consumer supplies the message.
 */
export function AuthStatusMessage({ children }: { children: ReactNode }) {
  return (
    <p role="status" className="text-text-primary">
      {children}
    </p>
  );
}
